import axios from "axios";

const API_URL = window.__KALIBER_CONFIG__.API_URL;

export const Axios = axios.create({
    baseURL: API_URL
})